import { GitLabState } from "@/store/gitlab/state";
import { getStoreAccessors } from "typesafe-vuex";
import { State as RootState } from "../state";
import GitLabInfo from "@/interfaces/gitlab/GitLabInfo";
import { defaultState } from "@/store/gitlab/index";

export const mutations = {
  setAccessToken(state: GitLabState, payload: string) {
    state.gitlab.accessToken = payload;
  },

  setGitLabInfo(state: GitLabState, payload: GitLabInfo) {
    state.gitlab = payload;
  },

  setProjectId(state: GitLabState, payload: number) {
    state.gitlab.projectId = payload;
  },

  setBranch(state: GitLabState, payload: string) {
    state.gitlab.branch = payload;
  },

  resetState(state: GitLabState) {
    Object.assign(state, defaultState);
  }
};

const { commit } = getStoreAccessors<GitLabState, RootState>("");

export const commitSetGitLabInfo = commit(mutations.setGitLabInfo);
export const commitSetAccessToken = commit(mutations.setAccessToken);
export const commitSetProjectId = commit(mutations.setProjectId);
export const commitSetBranch = commit(mutations.setBranch);
export const commitResetGitLab = commit(mutations.resetState);
